function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Sortable from 'sortablejs';
import data from './mixins/index.js';
import { jobSelectApi, hayGroupApi, getHayGroupApi, putHayGroupApi } from '@/api/config.js';
export default {
  mixins: [data],
  components: {
    tableList: function tableList() {
      return import('./components/tableList');
    },
    selectMember: function selectMember() {
      return import('@/components/form-common/select-member');
    },
    historyList: function historyList() {
      return import('./components/historyList');
    },
    exportExcel: function exportExcel() {
      return import('@/components/common/exportExcel');
    }
  },
  data: function data() {
    return {
      type: 'list',
      name: '评估表',
      title: '新增评估表',
      position: [],
      choiceEdit: 0,
      pageLoading: false,
      onlyDepartment: false,
      loading: false,
      exportData: {
        data: [],
        cols: [{
          wpx: 70
        }, {
          wpx: 70
        }, {
          wpx: 120
        }]
      },
      saveName: '下载表格.xlsx',
      selectedList: [],
      // 选中的职位id
      list: []
    };
  },
  computed: {
    // 智能分析
    getScore: function getScore() {
      return function (x, y, z) {
        if (x && y && z) {
          var num = x.toString() + y.toString() + z.toString();
          return Number(num);
        }
      };
    },
    // 解决问题
    getSolve: function getSolve() {
      return function (x, y) {
        if (x && y) {
          var num = x.toString() + y.toString();
          return Number(num);
        }
      };
    },
    // 承担责任
    getBear: function getBear() {
      return function (x, y, z) {
        if (x && y && z) {
          var num = x.toString() + y.toString() + z[0].toString() + z[1].toString();
          return Number(num);
        }
      };
    }
  },
  mounted: function mounted() {
    this.jobSelect();
  },
  methods: {
    // 触发职位选择事件
    selectedPosition: function selectedPosition(e) {
      var _this = this;
      this.list.map(function (item) {
        _this.selectedList.push(item.col1);
      });
    },
    // 打开历史记录弹窗
    openHistory: function openHistory(data) {
      this.$refs.history.openBox(data);
    },
    // 获取职位下拉列表
    jobSelect: function jobSelect() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return jobSelectApi();
            case 2:
              result = _context.sent;
              _this2.position = result.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 删除
    deleteFn: function deleteFn(data) {
      var _this3 = this;
      if (data.row.col15) {
        this.$modalSure('你确定要删除这条数据吗').then(function () {
          _this3.list.splice(data.$index, 1);
        });
      } else {
        this.list.splice(data.$index, 1);
      }
      if (data.row.col1) {
        this.selectedList = this.selectedList.filter(function (item) {
          return item == data.row.col11;
        });
      }
    },
    // 自动新增行
    addANewLine: function addANewLine() {
      var list = {
        col1: null,
        col2: null,
        col3: null,
        col4: null,
        col5: null,
        col6: null,
        col7: null,
        col8: null,
        col9: null,
        col10: null,
        col11: null,
        col12: null,
        col13: '',
        col14: ''
      };
      this.list.push(list);
    },
    // 岗位分数和岗位系数计算
    positionScore: function positionScore(row) {
      if (Number(row.col13) > 80) {
        row.col13 = 80;
      } else if (Number(row.col13) < 20) {
        row.col13 = 20;
      }
      row.col14 = 100 - Number(row.col13);
      var index5 = this.getScore(row.col2, row.col3, row.col4);
      var index8 = this.getSolve(row.col6, row.col7);
      var index12 = this.getBear(row.col9, row.col10, row.col11);
      if (index5 && index8 && index12 && row.col13 && row.col14) {
        var col5Value = this.score[index5].find(function (key) {
          return key.id == row.col5;
        }).label;
        var col8Value = this.solve[index8].find(function (key) {
          return key.id == row.col8;
        }).label;
        var col12Value = this.bear[index12].find(function (key) {
          return key.id == row.col12;
        }).label;
        var col13Value = Number(row.col13) / 100;
        var col14Value = Number(row.col14) / 100;
        var A = col13Value * col5Value;
        var B = Number(col8Value.replace('%', '')) / 100 + 1;
        var C = col14Value * col12Value;
        var num = A * B + C;
        row.col15 = num.toFixed(2);
        var result = [];
        this.list.map(function (item) {
          if (item.col15) {
            result.push(Number(item.col15));
          }
        });
        var D = 0;
        if (result.length == 1) {
          D = row.col15;
        } else {
          D = result.reduce(function (x, y) {
            return x < y ? x : y;
          });
        }
        var coefficient = row.col15 / D;
        row.col16 = coefficient.toFixed(2);
      }
    },
    // 保存
    submit: function submit() {
      var _this4 = this;
      var result = true;
      this.list.map(function (item, index) {
        if (!item.col1) {
          result = false;
        }
      });
      if (!result) {
        return this.$message.error('请选择职位');
      }
      this.loading = true;
      var data = {
        name: this.name,
        list: this.list
      };
      if (this.type == 'add') {
        hayGroupApi(data).then(function (res) {
          _this4.loading = false;
          _this4.type = 'list';
        }).catch(function (err) {
          _this4.loading = false;
        });
      } else if (this.type == 'edit') {
        putHayGroupApi(this.id, data).then(function (res) {
          _this4.loading = false;
          _this4.type = 'list';
        }).catch(function (err) {
          _this4.loading = false;
        });
      }
    },
    // 选择部门/员工
    selectPosition: function selectPosition() {
      this.$refs.selectMember.handlePopoverShow();
    },
    // 选择人员回调
    getSelectList: function getSelectList(data) {
      var _this5 = this;
      var userList = [];
      if (data.length > 0) {
        userList = data;
      }
      userList.map(function (item) {
        if (item.job) {
          var _data = {
            id: item.job.id,
            label: item.job.name
          };
          _this5.selectedList.push(_data.id);
          _this5.selectedList = Array.from(new Set(_this5.selectedList));
          _this5.list.push({
            col1: _data.id,
            col2: null,
            col3: null,
            col4: null,
            col5: null,
            col6: null,
            col7: null,
            col8: null,
            col9: null,
            col10: null,
            col11: null,
            col12: null,
            col13: '',
            col14: '',
            col15: '',
            col16: ''
          });
          _this5.list = _this5.filterRepeat(_this5.list);
        }
      });
      this.close();
    },
    // 去重
    filterRepeat: function filterRepeat(arr) {
      arr = arr.filter(function (element, index, self) {
        return self.findIndex(function (el) {
          return el.col1 === element.col1;
        }) === index;
      });
      return arr;
    },
    // 新增
    addType: function addType() {
      var _this6 = this;
      this.list = [];
      this.selectedList = [];
      this.type = 'add';
      this.title = '新增评估表';
      this.name = '评估表' + this.$moment(new Date()).format('YYYYMMDD');
      this.addANewLine();
      setTimeout(function () {
        _this6.rowDrop();
        _this6.$refs.inputFocus.focus();
      }, 500);
    },
    // 编辑
    editType: function editType(data) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this7.pageLoading = true;
              _this7.type = 'edit';
              _this7.title = '编辑评估表';
              _this7.name = data.name;
              _this7.id = data.id;
              _context2.next = 7;
              return getHayGroupApi(data.id);
            case 7:
              result = _context2.sent;
              _this7.list = result.data;
              _this7.pageLoading = false;
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 返回到模板列表
    goBack: function goBack() {
      this.type = 'list';
    },
    // 下载表格
    exportExcelData: function exportExcelData() {
      var _this8 = this;
      var aoaData = [['职位名称', '岗位分数', '岗位系数']];
      if (this.list.length > 0) {
        this.list.forEach(function (value) {
          _this8.position.map(function (item) {
            if (item.id == value.col1) {
              value.col1 = item.name;
            }
          });
          aoaData.push([value.col1, value.col15, value.col16]);
          _this8.exportData.data = aoaData;
        });
        this.$refs.exportExcel.exportExcel();
      }
    },
    // 表格拖拽函数
    rowDrop: function rowDrop() {
      var _this9 = this;
      var tbody = this.$refs.table.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0];
      Sortable.create(tbody, {
        animation: 300,
        onEnd: function onEnd(e) {
          var targetRow = _this9.list.splice(e.oldIndex, 1)[0];
          _this9.list.splice(e.newIndex, 0, targetRow);
        }
      });
    },
    // 使用历史记录
    applyFn: function applyFn(data, index) {
      this.list[index].col1 = data.col1;
      this.list[index].col2 = data.col2;
      this.list[index].col3 = data.col3;
      this.list[index].col4 = data.col4;
      this.list[index].col5 = data.col5;
      this.list[index].col6 = data.col6;
      this.list[index].col7 = data.col7;
      this.list[index].col8 = data.col8;
      this.list[index].col9 = data.col9;
      this.list[index].col10 = data.col10;
      this.list[index].col11 = data.col11;
      this.list[index].col12 = data.col12;
      this.list[index].col13 = data.col13;
      this.list[index].col14 = data.col14;
      this.list[index].col15 = data.col15;
      this.list[index].col16 = data.col16;
    }
  }
};